
import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/hooks/use-toast";

export const fetchUsers = async () => {
  console.log("Buscando dados de usuários...");
  const { data: allUsersData, error: allUsersError } = await supabase.functions.invoke('get-all-users');
  
  if (allUsersError) {
    console.error("Erro ao buscar todos os usuários:", allUsersError);
    throw allUsersError;
  }
  
  if (allUsersData && allUsersData.length > 0) {
    console.log(`Encontrados ${allUsersData.length} usuários combinados`);
    return allUsersData;
  }
  
  console.log("Tentando buscar usuários diretamente da tabela...");
  const { data: usersData, error: usersError } = await supabase
    .from('users')
    .select('*');

  if (usersError) {
    console.error("Erro ao buscar usuários diretamente:", usersError);
    throw usersError;
  }
  
  console.log(`Encontrados ${usersData?.length || 0} usuários na tabela users`);
  return usersData || [];
};

export const syncUsers = async () => {
  console.log("Iniciando sincronização manual de usuários via admin...");
  const { data: syncResult, error: syncError } = await supabase.functions.invoke('sync-auth-users');
  
  if (syncError) {
    console.error("Erro ao sincronizar usuários:", syncError);
    throw syncError;
  }
  
  console.log("Sincronização manual concluída:", syncResult);
  return syncResult;
};

export const toggleUserChatAccess = async (userId: string, currentStatus: boolean) => {
  console.log(`Alterando status de acesso ao chat para usuário ${userId}. Status atual: ${currentStatus}`);
  
  try {
    const newStatus = !currentStatus;
    
    const { error } = await supabase
      .from('users')
      .update({ status_chat: newStatus })
      .eq('id', userId);
    
    if (error) {
      console.error("Erro ao atualizar status_chat:", error);
      throw error;
    }
    
    console.log("Status de acesso ao chat atualizado com sucesso para usuário específico!");
    return true;
  } catch (error) {
    console.error("Erro completo ao tentar atualizar status de acesso:", error);
    throw error;
  }
};
